import { createI18n } from "vue-i18n";
import en from "@/assets/locales/en.json";
import country_en from "@/assets/locales/countries/countries_en.json";
import type { PublicConfigStatic } from "@mimsights-shared/types";
function detectLocale(): string {
  // const stored = localStorage.getItem('locale');
  // if (stored) return stored;
  // const navigatorLang = window.navigator.language.slice(0, 2);
  // if (['en', 'sv'].includes(navigatorLang)) return navigatorLang;
  return "en";
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: "en",
  // A copy: setBrand merges into these messages, and the defaults below must stay as they are
  messages: { en: { ...structuredClone(en), countries: country_en } },
});

export default i18n;

// Types the keys of useI18n()'s t() from en.json, so editors complete them. Any string is still
// accepted (dynamic keys); src/assets/locales/tests/en.test.ts checks that the keys exist.
declare module "vue-i18n" {
  export interface DefineLocaleMessage extends Messages {}
}
type Messages = typeof en;

type Brand = typeof en.brand;

// A configured name as a literal, so characters like @, { or | in it aren't read as message syntax
function literal(text: string): string {
  return `{'${text.replace(/\\/g, "\\\\").replace(/'/g, "\\'")}'}`;
}

// "Box" -> "Boxes", "Buddy" -> "Buddies", "Unit" -> "Units". The config has no plural, and the
// names in use are English.
export function pluralize(name: string): string {
  if (/[^aeiou]y$/i.test(name)) return `${name.slice(0, -1)}ies`;
  return /(s|x|z|ch|sh)$/i.test(name) ? `${name}es` : `${name}s`;
}

/**
 * Fills the `brand` messages from the entity's public config, so every message that links to
 * them (`@:brand.mimbox`) shows the entity's own names. Names the config leaves unset keep the
 * defaults in en.json.
 */
export function setBrand(config: Partial<PublicConfigStatic>) {
  const brand: Brand = { ...en.brand };
  if (config.baseName) brand.app = literal(config.baseName);
  if (config.siteName) {
    brand.site = literal(config.siteName);
    brand.dashboard = literal(config.siteName);
  }
  if (config.mimboxName) {
    brand.mimbox = literal(config.mimboxName);
    brand.mimboxes = literal(pluralize(config.mimboxName));
  }
  if (config.mimboxShortName) {
    brand.boxes = literal(pluralize(config.mimboxShortName));
  }
  i18n.global.mergeLocaleMessage("en", { brand });
}
